export * from './splash-view.component';
